define.alias("shared/components/shared/ui/mobile-menu", "settings/components/shared/ui/mobile-menu");